import type { ShiftRQSchema } from '@libs/data-access/queries'
import moment from 'moment'
import React from 'react'
import type { FC } from 'react'

import { PadCard } from '../../../components/PadCard/PadCard'
import { RealCard } from '../../../components/RealCard/RealCard'

import styles from './UnplannedBlockHoursInfo.module.css'
import { UnplannedCard } from './UnplannedCard/UnplannedCard'

type Props = {
  shift?: ShiftRQSchema
  color?: string
  isManager: boolean
  hasSnapPadBreakEnable: boolean
}
export const UnplannedBlockHoursInfo: FC<Props> = ({
  shift,
  color,
  isManager,
  hasSnapPadBreakEnable
}) => {
  if (!shift) {
    return
  }

  const totalRealBreakTime =
    shift.shift_breaks?.length > 0
      ? shift.shift_breaks?.reduce(
          (accumulator, breakItem) =>
            (accumulator ?? 0) + (breakItem?.real_duration ?? 0),
          0
        )
      : 0

  const shiftEvents = shift?.shift_events

  const clockInEvent =
    shiftEvents && shiftEvents.find(event => event?.event_type === 'clock_in')
  const clockOutEvent =
    shiftEvents && shiftEvents.find(event => event?.event_type === 'clock_out')

  const shiftIsFinishedWithoutOut =
    !clockOutEvent && moment(shift?.ends_at) < moment(new Date())

  const isValidated = Boolean(shift?.validated_at)

  const hasRealCard =
    shiftIsFinishedWithoutOut || Boolean(clockOutEvent) || isValidated

  const hasEmployeeModifyReal = Boolean(
    shift?.real_hours_last_modified_by_employee_at
  )

  const isShiftValid = Boolean(shift?.validator)

  const shouldDisplayRealCard =
    (isManager && hasEmployeeModifyReal) || isShiftValid

  return (
    <div className={styles.BlockContainer}>
      <UnplannedCard />
      <PadCard
        shift={shift}
        shiftIsFinishedWithoutOut={shiftIsFinishedWithoutOut}
        clockInEvent={clockInEvent}
        clockOutEvent={clockOutEvent}
        hasSnapPadBreakEnable={hasSnapPadBreakEnable}
      />
      {shouldDisplayRealCard && (
        <RealCard
          color={color}
          shift={shift}
          hasRealCard={hasRealCard}
          totalRealBreakTime={totalRealBreakTime}
          shiftIsFinishedWithoutOut={shiftIsFinishedWithoutOut}
          isShiftValid={isShiftValid}
        />
      )}
    </div>
  )
}
